// this will make it compatible with Nuxt authentication
export const AUTH_INFO_COOKIE = 'glovo_auth_info'
